export class QueueDeletedEvent {
    constructor({ transfer }) {
        this.name = 'queueDeleted';
        this.transfer = { ...transfer };
    }
    get data() {
        return {
            transfer: this.transfer,
        };
    }
}
